import { useTranslation } from 'react-i18next';

import {
  DragDropPlaceholder,
  DroppableList,
} from '@/components/ui/custom/dataInput/DragDrop';
import { CreateLessonPlanItemBody } from '@/data/services/lessonPlanItemServices';
import LessonPlanItem, { LessonPlanItemDTO } from '@/models/LessonPlanItem';

import LessonPlanItemCard from './LessonPlanItemCard';
import LessonPlanItemFormList from './LessonPlanItemFormList';
import { LessonPlanDndType } from './LessonPlansTabContent';
import { twMerge } from 'tailwind-merge';

type LessonPlanItemListProps = {
  lessonPlanId: number;
  items: LessonPlanItem[];
  coursePathId: number;
  courseLineId: number;
  isReordering?: boolean;
  onCreate: (body: CreateLessonPlanItemBody) => Promise<LessonPlanItem>;
  isCreating: boolean;
  onUpdate: (params: {
    lessonPlanItemId: number;
    data: Partial<LessonPlanItemDTO>;
  }) => Promise<LessonPlanItem>;
  isUpdating: boolean;
  isDeleting?: boolean;
  onDelete: (lessonPlanItemId: number) => Promise<void>;
};

export default function LessonPlanItemList({
  lessonPlanId,
  items,
  coursePathId,
  courseLineId,
  isReordering,
  onCreate,
  isCreating,
  onUpdate,
  isUpdating,
  isDeleting,
  onDelete,
}: LessonPlanItemListProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'courseLineForm.lessonPlansTab',
  });

  return (
    <div
      className={twMerge(
        'relative',
        items.length === 0 && 'flex flex-col gap-6',
      )}
    >
      <DroppableList
        groupId={String(lessonPlanId)}
        type={LessonPlanDndType.LESSON_PLAN_ITEM}
        className="relative flex flex-col min-h-12"
        placeholder={props => (
          <DragDropPlaceholder text={t('itemDndPlaceholder')} {...props} />
        )}
      >
        {items.map((lessonPlanItem, index) => (
          <LessonPlanItemCard
            key={lessonPlanItem.id}
            lessonPlanItem={lessonPlanItem}
            index={index}
            isDraggable
            isReordering={isReordering}
            coursePathId={coursePathId}
            courseLineId={courseLineId}
            onUpdate={onUpdate}
            isUpdating={isUpdating}
            isDeleting={isDeleting}
            onDelete={onDelete}
          />
        ))}
      </DroppableList>
      <LessonPlanItemFormList
        coursePathId={coursePathId}
        courseLineId={courseLineId}
        onSubmit={data => onCreate({ ...data, lessonPlanId })}
        isLoading={isCreating}
      />
    </div>
  );
}
